import { render, staticRenderFns } from "./NlpWhatInReport.vue?vue&type=template&id=2368f9d2&scoped=true"
import script from "./NlpWhatInReport.vue?vue&type=script&lang=js"
export * from "./NlpWhatInReport.vue?vue&type=script&lang=js"
import style0 from "./NlpWhatInReport.vue?vue&type=style&index=0&id=2368f9d2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2368f9d2",
  null
  
)

export default component.exports